var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoShareLinkedin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico_linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 25 25 25 25 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_linkedin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(-0.500000, -0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.085,20.248 L7.886,20.248 L7.886,11.182 L6.085,11.182 L6.085,20.248 Z M4.585,21.748 L9.386,21.748 L9.386,9.682 L4.585,9.682 L4.585,21.748 Z",
    id: "Fill-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0852,20.2481 L19.8862,20.2481 L19.8862,14.1911 C19.8692,13.0621 19.6432,12.2201 19.2132,11.7011 C18.8152,11.2201 18.1982,10.9861 17.3252,10.9861 C16.1302,10.9861 15.3682,11.2861 14.8562,11.9581 L14.4142,12.5371 L13.5132,11.8931 L13.4582,11.1821 L11.8642,11.1821 L11.8642,20.2481 L13.6552,20.2481 L13.6552,15.5371 C13.6552,14.0251 15.3002,14.0251 15.8412,14.0251 C16.6332,14.0251 17.2192,14.2401 17.5822,14.6631 C17.9212,15.0581 18.0852,15.6021 18.0852,16.3281 L18.0852,20.2481 Z M21.3862,21.7481 L16.5852,21.7481 L16.5852,16.3281 C16.5852,15.8421 16.4772,15.6781 16.4432,15.6401 C16.4182,15.6101 16.2532,15.5251 15.8412,15.5251 C15.6782,15.5251 15.3232,15.5251 15.1572,15.5721 L15.1552,21.7481 L10.3642,21.7481 L10.3642,9.6821 L14.9422,9.6821 L14.9452,9.9781 C15.6002,9.6481 16.3892,9.4861 17.3252,9.4861 C18.6542,9.4861 19.6792,9.9101 20.3692,10.7451 C21.0222,11.5341 21.3632,12.6891 21.3862,14.1801 L21.3862,21.7481 Z",
    id: "Fill-2",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.966,4.752 C6.23,4.752 5.63,5.351 5.63,6.088 C5.63,6.825 6.23,7.424 6.966,7.424 C7.702,7.424 8.302,6.825 8.302,6.088 C8.302,5.351 7.702,4.752 6.966,4.752 M6.966,8.924 C5.403,8.924 4.13,7.652 4.13,6.088 C4.13,4.524 5.403,3.252 6.966,3.252 C8.529,3.252 9.802,4.524 9.802,6.088 C9.802,7.652 8.529,8.924 6.966,8.924",
    id: "Fill-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoShareLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_share_linkedin.8f0964507f895f4ec96cc9546ac04c66.svg";